import Button from '@mui/material/Button';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import type { MouseEvent, PropsWithChildren } from 'react';

type FiltersBarButtonProps = PropsWithChildren<{
  onClick: (e: MouseEvent<HTMLElement>) => void;
  isActive: boolean;
  dataTest?: string;
  disabled?: boolean;
  hideOpenIcon?: boolean;
  sx?: SystemStyleObject<Theme>;
  disableRipple?: boolean;
}>;

const getColorStyles = (isActive: boolean, disabled = false): SystemStyleObject<Theme> =>
  disabled
    ? {
        bgcolor: 'background.boxDarker',
      }
    : {
        '&.MuiButton-root': {
          color: isActive ? 'primary.main' : 'text.secondary',
        },
        bgcolor: isActive ? 'primary.light' : 'background.boxDarker',
      };

export const FiltersBarButton = ({
  onClick,
  isActive,
  children,
  dataTest,
  disabled,
  hideOpenIcon,
  sx,
  disableRipple,
}: FiltersBarButtonProps) => {
  return (
    <Button
      sx={{
        ...getColorStyles(isActive, disabled),
        textTransform: 'unset',
        svg: hideOpenIcon
          ? {
              display: 'none',
            }
          : {
              marginLeft: 1,
              width: 18,
              height: 18,
            },
        height: 32,
        ...sx,
      }}
      size="medium"
      onClick={onClick}
      data-test={dataTest || 'filters-bar-button'}
      disabled={disabled}
      disableRipple={disableRipple}
    >
      {children}
    </Button>
  );
};
